import React from 'react';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { URL_DASHBOARD } from 'Helpers/Paths';
import { useNavigate } from 'react-router-dom';
import { Box, Stack } from '@mui/material';

const PageNotFound = () => {
    const navigate = useNavigate();

    const backToDashboard = () => {
        navigate(URL_DASHBOARD);
    };

    return (
        <Stack alignItems={'center'} justifyContent={'center'} gap={2} sx={{ height: '100vh' }}>
            <Typography variant="h1" style={{ color: '#002047', fontWeight: 600 }}>
                404
            </Typography>
            <Typography variant="h4" mb={2} style={{ color: '#002047' }}>
                Page Not found
            </Typography>
            <Box>
                <Button
                    onClick={backToDashboard}
                    style={{ backgroundColor: '#F5E0B5', color: '#333333', marginTop: '10px' }}
                    type="submit"
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}>
                    Back To Dashboard
                </Button>
            </Box>
        </Stack>
    );
};
export default PageNotFound;
